import { inversionApi } from './api';
import { parseInversionFile, isServerParsedFormat, productToModel } from './inversion-parser';

/**
 * Text of an inversion file -> the normalized model shape: server-parsed formats (EarthImager
 * .out/.mod, 3D InvRes .dat, BERT, ...) go through POST /api/inversion/parse, the 2D text exports
 * are parsed in the browser. Shared by the Inversion panel's import and the 3D viewer's sample loader.
 */
export async function readInversionModel(text, fileName, iteration = null) {
  if (isServerParsedFormat(fileName, text)) {
    const res = await inversionApi.parse({ content: text, file_name: fileName, iteration });
    return productToModel(res.data, fileName);
  }
  return { ...parseInversionFile(text, fileName), geometryKind: 'line', electrodes: [], crs: 'local' };
}
